module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dragOrclick":"click on the video you want to play from the left or drag it here"},"zh":{"dragOrclick":"从左侧单击要播放的视频，或将其拖动到此处"}}')
  delete Component.options._Ctor
}
